<template>
  <div v-if="List.length != 0" style="padding-bottom: 100px">
    <el-card style="margin-bottom: 20px">
      <div slot="header">
        <span style="font-weight: 600; font-size: 20px">主题评价说明</span>
      </div>
      <div class="tui-Box">
        <div v-for="(item, index) in subjectArr" :key="index">
          <div
            class="tui-subjectTitle"
            style="font-size: 14px; font-weight: bold"
          >
            {{ item.Title }}：
          </div>
          <div
            class="tui-subjectTitle"
            style="
              white-space: pre-line;
              margin-top: -14px;
              margin-bottom: 20px;
            "
          >
            {{ item.Desc }}
          </div>
        </div>
      </div>
    </el-card>
    <el-card>
      <div slot="header">
        <span style="font-weight: 600; font-size: 20px">主题评价操作</span>
      </div>
      <template v-for="(list, keys) in List">
        <div :key="keys" v-if="list.isShowKeyWord">
          <div class="tui-Box">
            <div class="gradeBox">
              <div class="evaluateTitle" v-if="list.isShowKeyWord">
                {{ list.EvaluateTitle }}
              </div>
              <template v-for="(item, index) in list.KeyWordList">
                <div
                  :key="index"
                  v-if="item.DescribeList.length != 0"
                  ref="isOverflow"
                >
                  <div class="keyword" id="offsetTitle">
                    {{ item.KeyWord }}
                  </div>
                  <div class="table" style="margin: 0">
                    <div class="tableHeader row">
                      <div class="lineOne">描述</div>
                      <div class="lineTwo">需努力</div>
                      <div class="lineThere">较好</div>
                      <div class="lineFour">好</div>
                    </div>
                    <div
                      class="row"
                      v-for="(itemLine, indexLine) in item.DescribeList"
                      :key="indexLine"
                    >
                      <template>
                        <div class="lineOne">
                          {{ itemLine.Text }}
                        </div>
                        <div
                          class="lineTwo"
                          v-for="(itemStar, indexStar) in list.starInfo"
                          :key="indexStar"
                        >
                          <div
                            class="starBox"
                            v-for="(itemStarTwo, indexStarTwo) in itemStar"
                            :key="indexStarTwo"
                            @click="
                              scoreCheck(
                                keys,
                                index,
                                indexLine,
                                itemStarTwo.Score
                              )
                            "
                          >
                            <img
                              v-if="itemLine.Score >= itemStarTwo.Score"
                              src="../../assets/starActive.png"
                            />
                            <img v-else src="../../assets/star.png" />
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <!-- P2 -->
          <template v-if="!$route.query.typeStatus">
            <div v-for="(edits, indes) in list.secondDescResults" :key="indes">
              <div class="tui-teacher">{{ edits.Title }}</div>
              <div v-if="edits.QuestionType == 2 || edits.QuestionType == 4">
                <div class="statueTesting">
                  <div class="statueTesting_title">照片</div>
                </div>
                <el-upload
                  :on-exceed="imageUpdateExceed"
                  ref="upload"
                  action="/api/Img/UploadImage/"
                  list-type="picture-card"
                  :on-remove="handleUploadRemove"
                  :on-success="handleUploadSuccess"
                  :on-change="handleFileChange"
                  :before-upload="beforeAvatarUpload"
                  :file-list="edits.ImgList"
                  :headers="headers"
                  :multiple="true"
                  :limit="6"
                >
                  <!--  -->
                  <!--   -->
                  <!-- :file-list="edits.ImgList"  -->
                  <!--  -->
                  <i
                    class="el-icon-plus"
                    @click="onClickUpload(keys, indes)"
                  ></i>
                </el-upload>
              </div>
              <div
                style="padding: 20px 0"
                v-if="edits.QuestionType == 3 || edits.QuestionType == 4"
              >
                <div class="statueTesting">
                  <div class="statueTesting_title">
                    {{
                      indes == 0
                        ? "老师的话"
                        : indes == 1
                        ? "爸爸妈妈的话"
                        : indes == 2
                        ? "宝宝来加油"
                        : "我想说的话"
                    }}
                  </div>
                </div>
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入内容(最多输入300字)"
                  v-model="edits.Text"
                  show-word-limit
                  maxlength="300"
                >
                </el-input>
                <prefabricatedText
                  :maxTextLength="300"
                  MessageType="主题评价默认模板"
                  @select="coverContentSelect"
                  :addition="[keys, indes]"
                ></prefabricatedText>
              </div>
            </div>
          </template>
          <div class="tui-btns">
            <el-button
              type="primary"
              v-if="!$route.query.typeStatus"
              @click="onClickSubmit"
              >提交</el-button
            >
          </div>
          <div v-if="$route.query.typeStatus" style="margin-top: 20px">
            <el-button type="primary" @click="onClickAdd">批量提交</el-button>
          </div>
        </div>
      </template>
    </el-card>
  </div>
</template>
<script>
import {
  GetBabyEval_ThemeDetail,
  SaveBabyEval_ThemeDetail,
  SaveCacheThemeInfo,
  GetThemeDesc,
} from "../../api/api";
import { mapState } from "vuex";
import * as myModule from "../../../util/validate";
import prefabricatedText from "../../components/PrefabricatedText.vue";
export default {
  data() {
    return {
      List: [],
      indexs: 0,
      keys: 0,
      GrowthMessageTextLists: [],
      textarea: "",
      subjectArr: [],
    };
  },
  created() {
    this.GetBabyEval_ThemeDetail();
    this.GetThemeDesc();
    console.log(this.$route.query);
  },
  components: {
    prefabricatedText,
  },
  computed: {
    ...mapState({
      headerToken: (state) => state.token,
    }),
    headers() {
      return {
        Authorization: this.headerToken, // 直接从本地获取token就行
      };
    },
  },
  methods: {
    coverContentSelect(e) {
      //console.log(this.List[e.addition[0]]);

      this.coverContent = e.content;
      this.List[e.addition[0]].secondDescResults[e.addition[1]].Text =
        e.content;
    },
    async GetThemeDesc() {
      let res = await GetThemeDesc({ ThemeId: this.$route.query.ThemeId });
      if (res.data.success) {
        this.subjectArr = res.data.response;
      }
    },
    onClickAdd() {
      let questions = [];
      for (let a = 0; a < this.List.length; a++) {
        let themeInfo = this.List[a];
        if (themeInfo.IsEdit) {
          //非只读的判断必填项
          //整理表格打分 及判断是否打分
          for (let i = 0; i < themeInfo.KeyWordList.length; i++) {
            let KeyWordItem = themeInfo.KeyWordList[i];
            for (let j = 0; j < KeyWordItem.DescribeList.length; j++) {
              let DescribeItem = KeyWordItem.DescribeList[j];
              if (DescribeItem.Score == 0) {
                this.$message({
                  type: "error",
                  message: "您有打分项未填写",
                });

                return;
              } else {
                // questionType 1问题打分 2是图片 3是文字 4是文字+图片
                questions.push({
                  eval_ThemeQuestionId: DescribeItem.Eval_ThemeQuestionId,
                  score: DescribeItem.Score,
                });
              }
            }
          }
        }
      }
      let arrs = [];
      let result = [];
      arrs = JSON.parse(this.$route.query.themeMapIds);
      result = arrs.map((cc) => cc.ThemeMapId);
      //console.log(result);
      const params = {
        ThemeId: this.$route.query.ThemeId,
        themeMapIds: result,
        questions: questions,
      };
      //console.log(params);
      SaveCacheThemeInfo(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.$router.replace({
            path: "/SubjectResult/index",
            query: {
              params: this.$route.query.params,
            },
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    //   提交
    onClickSubmit() {
      let ListCopy = JSON.parse(JSON.stringify(this.List));
      let questions = [];
      let isWriteTable = true; //是否表格
      let isWriteImage = true; //是否填写图片
      let isWriteText = true; //是否填写文字
      let isWriteImageIntact = true; //图片是否填写完整
      let eval_ThemeDetailId = "";
      for (let a = 0; a < ListCopy.length; a++) {
        let themeInfo = ListCopy[a];
        if (themeInfo.IsEdit) {
          //非只读的判断必填项
          //整理表格打分 及判断是否打分
          eval_ThemeDetailId = themeInfo.Eval_ThemeDetailId;
          for (let i = 0; i < themeInfo.KeyWordList.length; i++) {
            let KeyWordItem = themeInfo.KeyWordList[i];
            for (let j = 0; j < KeyWordItem.DescribeList.length; j++) {
              let DescribeItem = KeyWordItem.DescribeList[j];
              if (DescribeItem.Score == 0) {
                // this.$message({
                //   type: "error",
                //   message: "您有打分项未填写",
                // });
                isWriteTable = false;
              } else {
                // questionType 1问题打分 2是图片 3是文字 4是文字+图片
                questions.push({
                  eval_ThemeQuestionId: DescribeItem.Eval_ThemeQuestionId,
                  questionType: 1,
                  img: "",
                  content: "",
                  score: DescribeItem.Score,
                });
              }
            }
          }
          for (let i = 0; i < themeInfo.secondDescResults.length; i++) {
            let secondDesc = themeInfo.secondDescResults[i];
            if (secondDesc.QuestionType == 2) {
              //图片
              if (secondDesc.ImgList.length == 0) {
                // this.$message({
                //   type: "error",
                //   message: "请上传图片",
                // });
                isWriteImage = false;
                isWriteImageIntact = false;
              } else {
                if (a == 0 && secondDesc.ImgList.length < 6) {
                  isWriteImageIntact = false;
                } else if (a == 1 && secondDesc.ImgList.length < 2) {
                  isWriteImageIntact = false;
                } else if (a == 2 && secondDesc.ImgList.length < 1) {
                  isWriteImageIntact = false;
                }

                let ImgList = [];
                secondDesc.ImgList.forEach((item) => {
                  ImgList.push(item.url);
                });
                questions.push({
                  eval_ThemeQuestionId: secondDesc.Eval_ThemeQuestionId,
                  questionType: secondDesc.QuestionType,
                  img: ImgList.join(","),
                  content: "",
                  // score: DescribeItem.Score
                });
              }
            } else if (secondDesc.QuestionType == 3) {
              //文字
              let Text = myModule.trim(secondDesc.Text);
              if (Text.length == 0) {
                // this.$message({
                //   type: "error",
                //   message: "请填写您想说的话",
                // });
                isWriteText = false;
              } else {
                questions.push({
                  eval_ThemeQuestionId: secondDesc.Eval_ThemeQuestionId,
                  questionType: secondDesc.QuestionType,
                  img: "",
                  content: secondDesc.Text,
                  // score: DescribeItem.Score
                });
              }
            } else if (secondDesc.QuestionType == 4) {
              //图片及文字
              let Text = myModule.trim(secondDesc.Text);
              if (Text.length == 0) {
                // this.$message({
                //   type: "error",
                //   message: "请填写您想说的话",
                // });
                isWriteText = false;
              }
              if (secondDesc.ImgList.length == 0) {
                // this.$message({
                //   type: "error",
                //   message: "请上传图片",
                // });
                isWriteImage = false;
                isWriteImageIntact = false;
              }
              if (secondDesc.ImgList.length != 0) {
                if (a == 0 && secondDesc.ImgList.length < 6) {
                  isWriteImageIntact = false;
                } else if (a == 1 && secondDesc.ImgList.length < 2) {
                  isWriteImageIntact = false;
                } else if (a == 2 && secondDesc.ImgList.length < 1) {
                  isWriteImageIntact = false;
                }
              }
              let ImgList = [];
              secondDesc.ImgList.forEach((item) => {
                ImgList.push(item.url);
              });
              questions.push({
                eval_ThemeQuestionId: secondDesc.Eval_ThemeQuestionId,
                questionType: secondDesc.QuestionType,
                img: ImgList.join(","),
                content: secondDesc.Text,
                // score: DescribeItem.Score
              });
            }
          }
        }
      }
      const params = {
        ThemeId: this.$route.query.ThemeId,
        ThemeMapId: this.$route.query.ThemeMapId,
        // eval_ThemeDetailId: ListCopy[0].Eval_ThemeDetailId,
        eval_ThemeDetailId: eval_ThemeDetailId,
        questions: questions,
      };
      if (
        isWriteTable == false &&
        isWriteImage == false &&
        isWriteText == false
      ) {
        this.$message({
          type: "error",
          message: "请完整的填写一个模块（文字/图片/打分）",
        });
        return;
      }

      if (
        isWriteTable == false ||
        isWriteImage == false ||
        isWriteText == false
      ) {
        const h = this.$createElement;
        this.$msgbox({
          title: "提示消息",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: true,
          type: "warning",
          message: h("div", null, [
            h(
              "p",
              { style: "color: red" },
              "您的评价内容尚未完成，是否继续提交？ "
            ),
            h("p", { style: "color: red" }, "注：本次提交后可再次编辑"),
          ]),
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              done();
              this.SaveBabyEval_ThemeDetailConfirm(params);
            } else {
              done();
            }
          },
        });
      } else {
        if (isWriteImageIntact) {
          this.SaveBabyEval_ThemeDetailConfirm(params);
        } else {
          this.$confirm("教师评价图片建议您上传6张，是否继续提交?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then((e) => {
              this.SaveBabyEval_ThemeDetailConfirm(params);
            })
            .catch(() => {});
        }
      }
    },
    // 确认提交
    SaveBabyEval_ThemeDetailConfirm(params) {
      SaveBabyEval_ThemeDetail(params).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.$router.replace({
            path: "/SubjectResult/index",
            query: {
              params: this.$route.query.params,
            },
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    scoreCheck(index, KeyWordListIndex, DescribeListIndex, score) {
      if (this.List[index].IsEdit) {
        this.List[index].KeyWordList[KeyWordListIndex].DescribeList[
          DescribeListIndex
        ].Score = score;
      }
    },
    UseGrowthMessage(text, index, keys) {
      this.List[index].secondDescResults[keys].Text = text;
    },
    // async getRecommend() {
    //   let res = await Recommend({
    //     PageSize: 20,
    //     MessageType: "主题评价默认模板",
    //   });
    //   if (res.data.success) {
    //     this.GrowthMessageTextLists = res.data.response.data;
    //     //console.log(this.GrowthMessageTextLists);
    //   } else {
    //     this.GrowthMessageTextLists = [];
    //   }
    // },

    onClickUpload(index, keys) {
      this.indexs = index;
      this.keys = keys;
    },
    handleUploadRemove(file) {
      let index = this.List[this.indexs].secondDescResults[
        this.keys
      ].ImgList.findIndex((c) => {
        return c.url == file.url;
      });
      this.List[this.indexs].secondDescResults[this.keys].ImgList.splice(
        index,
        1
      );
    },
    imageUpdateExceed(error) {
      this.$message({
        message: "最多可上传6张图片",
        type: "error",
      });
    },
    handleUploadSuccess(response) {
      if (
        this.List[this.indexs].secondDescResults[this.keys].ImgList.length < 6
      ) {
        this.List[this.indexs].secondDescResults[this.keys].ImgList.push({
          name: response.response,
          url: response.response,
        });
      } else {
        this.$message({
          message: "最多可上传6张图片",
          type: "error",
        });
      }
    },
    // 文件上传变化
    handleFileChange() {
      //是否展示图片+号
    },
    beforeAvatarUpload(file) {
      //console.log(file);
      if (
        this.List[this.indexs].secondDescResults[this.keys].ImgList.length >= 6
      ) {
        this.$message({
          message: "最多可上传6张图片",
          type: "warning",
        });

        return false;
      }
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "jpg" ||
        testmsg === "JPG" ||
        testmsg === "png" ||
        testmsg === "PNG" ||
        testmsg === "bpm" ||
        testmsg === "jpeg" ||
        testmsg === "JPEG" ||
        testmsg === "BPM";

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!extension) {
        this.$message({
          message: "上传图片只能是jpg / png / bpm /JPEG格式!",
          type: "error",
        });
        return false; //必须加上return false; 才能阻止
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return extension || isLt2M;
    },
    distinguish(Type) {
      let starInfo = [];
      // 三个子数组对应是哪个分数的单元格 子数组中的对象代表一个星星信息 score选择获得的分数
      if (Type == 1) {
        starInfo = [
          [
            {
              Score: 1,
            },
            {
              Score: 2,
            },
            {
              Score: 3,
            },
          ],
          [
            {
              Score: 4,
            },
            {
              Score: 5,
            },
            {
              Score: 6,
            },
          ],
          [
            {
              Score: 7,
            },
            {
              Score: 8,
            },
            {
              Score: 9,
            },
          ],
        ];
      } else {
        starInfo = [
          [
            {
              Score: 1,
            },
          ],
          [
            {
              Score: 2,
            },
          ],
          [
            {
              Score: 3,
            },
          ],
        ];
      }
      return starInfo;
    },
    // 获取报告
    GetBabyEval_ThemeDetail() {
      //console.log(this.$route.query);
      const params = {
        StudentId: this.$route.query.CustomerId,
        ThemeId: this.$route.query.ThemeId,
        ThemeMapId: this.$route.query.ThemeMapId,
        Identity: 1,
      };
      GetBabyEval_ThemeDetail(params).then((res) => {
        if (res.data.success) {
          for (let i = 0; i < res.data.response.length; i++) {
            let item = res.data.response[i];
            // 获取星星评分的结构
            item.starInfo = this.distinguish(item.Type);
            // 判断是否有评分题
            let isShowKeyWord = false;

            for (let j = 0; j < item.KeyWordList.length; j++) {
              // 存在一项评分题即存在
              if (item.KeyWordList[j].DescribeList.length != 0) {
                isShowKeyWord = true;
                break;
              }
            }
            item.isShowKeyWord = isShowKeyWord;
          }
          res.data.response.forEach((element) => {
            element.secondDescResults.forEach((c, inds) => {
              if (c.ImgList.length != 0) {
                c.ImgList = c.ImgList.filter((item) => {
                  return item;
                });
                c.ImgList = c.ImgList.map((v) => {
                  return {
                    url: v,
                    name: "图片" + inds,
                  };
                });
              }
            });
          });
          this.List = [res.data.response[0]];
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.tui-btns {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
}

.statueTesting {
  width: 100%;

  .statueTesting_title {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #343434;
    padding-bottom: 0.25rem;
  }
}
.tui-teacher {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  text-align: center;
  padding: 0 30px;
  padding-top: 33px;
  padding-bottom: 22px;
}
.gradeBox {
  width: 100%;

  // box-shadow: 0px 4px 32px 3px rgba(57, 87, 181, 0.15);
  margin: 0 auto;

  .evaluateTitle {
    text-align: center;
    font-size: 40px;
    font-weight: 400;
    color: #333333;
    text-align: center;
    padding: 0 30px;
    padding-top: 33px;
    border-bottom: 1px solid #cdcdcd;
    padding-bottom: 22px;
  }

  .keyword {
    text-align: center;
    line-height: 64px;
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #305a9f;
    font-weight: 500;
  }

  .table {
    .tableHeader {
      border-top: 1px solid #cdcdcd;

      view {
        color: #000000 !important;
      }

      .lineOne {
        padding: 10px 0;
        width: 300px;
        text-align: center;
        font-size: 22px;
      }
    }

    .row {
      display: flex;
      border-bottom: 1px solid #cdcdcd;

      img {
        width: 27px;
        height: 26px;
      }

      .starBox {
        padding: 0px;
      }

      view {
        padding: 10px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 300;
        color: #666666;
      }

      .lineOne {
        padding: 10px;
        width: 470px;
        border-right: 1px solid #cdcdcd;
        border-left: 1px solid #cdcdcd;
        font-size: 20px;
      }

      .lineTwo {
        flex: 1;
        text-align: center;
        border-right: 1px solid #cdcdcd;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 22px;
      }

      .lineThere {
        flex: 1;
        text-align: center;
        border-right: 1px solid #cdcdcd;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 22px;
      }

      .lineFour {
        flex: 1;
        text-align: center;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 22px;
        border-right: 1px solid #cdcdcd;
      }
    }
  }
}
</style>